import { tss } from 'tss-react/mui';

const useStyles = tss.create(({ theme }) => ({
  messageInputAvatar: {
    fontSize: '1rem',
    height: '2rem',
    width: '2rem',
    [theme.breakpoints.down('sm')]: {
      display: 'none'
    }
  },
  messageInputMessageTemplatesSelect: {
    '&.MuiAutocomplete-root ': {
      '& .MuiAutocomplete-inputRoot': {
        display: 'flex',
        padding: `0 ${theme.spacing(1)}`
      }
    }
  },
  messageInputContainer: {
    width: '100%',
    border: `1px solid ${theme.vars.palette.border.main}`,
    borderRadius: theme.vars.shape.borderRadius,
    '.mdxeditor': {
      borderBottomLeftRadius: 0,
      borderBottomRightRadius: 0
    }
  },
  messageInputInput: {
    borderBottomLeftRadius: 0,
    borderBottomRightRadius: 0
  },
  messageInputOptionsContainer: {
    padding: theme.spacing(1, 2)
  },
  messageInputOptionsSection1: {
    alignItems: 'center',
    display: 'flex',
    width: '100%',
    [theme.breakpoints.up('xl')]: {
      width: '18.75rem'
    }
  },
  messageInputOptionsSection2: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    width: '100%',
    [theme.breakpoints.up('sm')]: {
      alignItems: 'center',
      flexDirection: 'row',
      gap: theme.spacing(2)
    }
  },
  messageInputTextField: {
    '& .MuiInputBase-root': {
      backgroundColor: theme.vars.palette.background.elevation2,
      '&.Mui-focused': {
        backgroundColor: theme.vars.palette.background.elevation2
      }
    },
    '& fieldset': {
      borderBottomColor:
        'rgba(var(--mui-palette-common-onBackgroundChannel) / 0.23)',
      borderBottomWidth: '0.031rem'
    }
  },
  messageInputTextFieldContainer: {
    borderTopRightRadius: '8px',
    borderTopLeftRadius: '8px',
    width: '100%'
  },

  messageInputFileChip: {
    backgroundColor: 'transparent',
    color: theme.vars.palette.primary.light,
    '&:hover': {
      backgroundColor: 'transparent',
      color: theme.vars.palette.text.primary
    },
    '&:focus': {
      backgroundColor: 'transparent',
      color: theme.vars.palette.text.primary
    }
  },
  messageInputFileDeleteIcon: {
    color: theme.vars.palette.common.white,
    '&:hover': {
      color: theme.vars.palette.text.primary_a75
    }
  },
  messageInputFileInput: {
    display: 'none'
  },
  mdxEditor: {
    width: '100%'
  }
}));

export default useStyles;
